"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "altavilla-irpina": {
    "ec729da7": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "skipSearch": false
    }],
    "belvedere": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b36f41c3": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "skipSearch": false
    }],
    "pannone-di-sopra": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43b6bb76": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "skipSearch": false
    }],
    "pannone-di-sotto": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fa9e7c66": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "skipSearch": false
    }],
    "russo": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1f0c6330": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "skipSearch": false
    }],
    "san-trifone": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7fa26e52": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "skipSearch": false
    }],
    "sassano": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f50e1bc9": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "skipSearch": false
    }],
    "toro": [{
      "hkey": "bfb10266",
      "slug": "altavilla-irpina",
      "name": "Altavilla Irpina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;